import api from './api';

const assignmentService = {
  /**
   * Create a new assignment
   * @param {Object} assignmentData - { emp_id, project_code, location_id, onboarding_date, offboarding_date, bill_rate }
   * @returns {Promise}
   */
  create: async (assignmentData) => {
    const response = await api.post('/assignments', assignmentData);
    return response.data.assignment;
  },

  /**
   * Get assignment by ID
   * @param {string} id - Assignment ID
   * @returns {Promise}
   */
  getById: async (id) => {
    const response = await api.get(`/assignments/${id}`);
    return response.data.assignment;
  },

  /**
   * Get all assignments (with optional filters)
   * @param {Object} params - { emp_id?, project_code?, active? }
   * @returns {Promise}
   */
  getAll: async (params = {}) => {
    const response = await api.get('/assignments', { params });
    return response.data.assignments;
  },

  /**
   * Get assignments for a specific employee
   * @param {string} empId - Employee ID
   * @returns {Promise}
   */
  getByEmployee: async (empId) => {
    const response = await api.get('/assignments', { params: { emp_id: empId } });
    return response.data.assignments;
  },

  /**
   * Get assignments for a specific project
   * @param {string} projectCode - Project code
   * @returns {Promise}
   */
  getByProject: async (projectCode) => {
    const response = await api.get('/assignments', { params: { project_code: projectCode } });
    return response.data.assignments;
  },

  /**
   * Get active assignments only
   * @returns {Promise}
   */
  getActive: async () => {
    const response = await api.get('/assignments', { params: { active: 'true' } });
    return response.data.assignments;
  },

  /**
   * Update an assignment
   * @param {string} id - Assignment ID
   * @param {Object} assignmentData - { onboarding_date?, offboarding_date?, bill_rate?, location_id? }
   * @returns {Promise}
   */
  update: async (id, assignmentData) => {
    const response = await api.put(`/assignments/${id}`, assignmentData);
    return response.data.assignment;
  },

  /**
   * Delete an assignment
   * @param {string} id - Assignment ID
   * @returns {Promise}
   */
  delete: async (id) => {
    const response = await api.delete(`/assignments/${id}`);
    return response.data;
  },
};

export default assignmentService;
